import api from './api';

export const getLandingPages = (page, params) => {
  return api.get('admin/LandingPage', { params: { page: page, limit: 5, ...params } });
};

export const sendPage = (file) => {
  const config = { headers: { 'content-type': 'multipart/form-data' } };
  return api.post(`admin/landingPage/import_page`, file, config);
};

export const deleteLandingPage = (id) => {
  return api.delete(`admin/landingPage/${id}`);
};
